import _ from 'lodash'

export default {

  props: {
    categoryIds: {
      type: Array,
      default: () => ([])
    },
    excludedIds: {
      type: Array,
      default: () => ([])
    },
    numberOfItems: {
      type: Number,
      default: 5
    },
  },

  data: () => ({
    items: [],
    commentCounts: []
  }),

  computed: {
    categories() {
      return this.categoryIds.join()
    },
    featuredPost() {
      return _.head(this.items)
    },
    otherItems() {
      return this.items.slice(1,this.numberOfItems)
    },
    itemIds() {
      return _.map(this.items, item => item.id)
    }
  }
}
